import { render, staticRenderFns } from "./StackedColumnChart.vue?vue&type=template&id=528ebd31&scoped=true"
import script from "./StackedColumnChart.vue?vue&type=script&lang=ts"
export * from "./StackedColumnChart.vue?vue&type=script&lang=ts"
import style0 from "./StackedColumnChart.vue?vue&type=style&index=0&id=528ebd31&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528ebd31",
  null
  
)

export default component.exports